import type { SlugifyOptions } from '#layers/ui';
import slugifyFn from 'slugify';

const defaultOptions: SlugifyOptions = { lower: true, strict: true };

export default function slugify(value: string, options?: SlugifyOptions): string;
export default function slugify(value?: undefined, options?: SlugifyOptions): undefined;
export default function slugify(value: string | undefined, options?: SlugifyOptions): string | undefined;
export default function slugify(value?: string, options?: SlugifyOptions): string | undefined {
	const mergedOptions = options ? { ...defaultOptions, ...options } : defaultOptions;
	return value !== undefined ? slugifyFn(value, mergedOptions) : value;
}
